import { useEffect, useState } from 'react';
import { Megaphone, ChevronRight, X, ArrowLeft } from 'lucide-react';
import { api, date } from '../api';
import { Modal } from './Modal';
import './home-announcements.css';

type Announcement = {id:string; title:string; body:string; published_at:string; ends_at:string|null};
const storageKey = 'moyu:home-announcements:dismissed:v1';
function readDismissed(): string[] {
  try { const ids:unknown=JSON.parse(localStorage.getItem(storageKey)||'[]'); return Array.isArray(ids)?ids.filter((id):id is string=>typeof id==='string').slice(-100):[]; } catch { return []; }
}
export function HomeAnnouncements() {
  const [items,setItems]=useState<Announcement[]>([]);
  const [dismissed,setDismissed]=useState(readDismissed);
  const [open,setOpen]=useState(false), [selected,setSelected]=useState<string|null>(null);
  useEffect(()=>{
    const controller=new AbortController(); let pending=false;
    async function refresh(){
      if(pending || document.hidden) return;
      pending=true;
      try {const result=await api<{items:Announcement[]}>('/announcements',{signal:controller.signal}); if(!controller.signal.aborted)setItems(result.items);}
      catch { /* An unavailable notice feed must never block the games. */ }
      finally {pending=false;}
    }
    void refresh();
    const timer=window.setInterval(()=>{setItems(current=>current.filter(a=>!a.ends_at||Date.parse(a.ends_at)>Date.now()));void refresh();},60000);
    const storage=(e:StorageEvent)=>{if(e.key===storageKey||e.key===null)setDismissed(readDismissed());};
    const show=()=>{setSelected(null);setOpen(true);void refresh();};
    window.addEventListener('focus',refresh);document.addEventListener('visibilitychange',refresh);
    window.addEventListener('storage',storage);window.addEventListener('moyu:open-announcements',show);
    return ()=>{controller.abort();clearInterval(timer);window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',refresh);window.removeEventListener('storage',storage);window.removeEventListener('moyu:open-announcements',show);};
  },[]);
  const current=items.find(a=>!dismissed.includes(a.id));
  const detail=items.find(a=>a.id===selected);
  function dismiss(){
    const ids=[...new Set([...dismissed,...items.map(a=>a.id)])].slice(-100);
    setDismissed(ids);try{localStorage.setItem(storageKey,JSON.stringify(ids));}catch{}
  }
  return <>
    {current && <aside className="home-notice" aria-label="首页公告"><div className="home-notice-inner">
      <button className="home-notice-read" onClick={()=>{setSelected(current.id);setOpen(true);}}>
        <Megaphone size={15}/><span className="home-notice-label">公告</span><span className="home-notice-title">{current.title}</span><span className="home-notice-view">查看</span><ChevronRight size={15}/>
      </button>
      <button className="home-notice-dismiss" onClick={dismiss} aria-label="关闭首页公告" title="关闭公告"><X size={16}/></button>
    </div></aside>}
    {open && <Modal title="岛上公告" onClose={()=>setOpen(false)} className="home-notice-dialog">
      <div className="home-notice-content">
        {detail ? <><button className="home-notice-back" onClick={()=>setSelected(null)}><ArrowLeft size={15}/>全部公告</button><h3>{detail.title}</h3><time>{date(detail.published_at)}</time><p className="home-notice-body">{detail.body}</p></> : <div className="home-notice-list">
          {items.length ? items.map(a=><button key={a.id} onClick={()=>setSelected(a.id)}><span><strong>{a.title}</strong><time>{date(a.published_at)}</time></span><ChevronRight size={18}/></button>):<p>暂无公告</p>}
        </div>}
      </div>
    </Modal>}
  </>;
}
